module.exports = __webpack_public_path__ + "img/selected0-min.b05adf47.png";